import { routes } from '../../../utils/helpers/ApiClient';
import React from 'react';
import { DashboardOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '../../../utils/helpers/UtilityComponents';
import { ROLE_ING_PROJECTS_ADMIN } from '../../../utils/constants/roles';

const appEnv = import.meta.env.VITE_APP_ENV || 'development';
const isProduction = appEnv === 'production';

const navItems = [
  {
    title: 'Profil',
    icon: <DashboardOutlined />,
    url: routes.cmsDashboard,
  },
  {
    title: 'Obsah',
    icon: <FontAwesomeIcon icon={'layer-group'} />,
    items: [
      {
        title: 'Aktuality',
        url: routes.cmsNews,
        permission: 'news.index',
      },
      {
        title: 'Banery',
        url: routes.cmsSliders,
        permission: 'sliders.index',
      },
      {
        title: 'Bloky',
        url: routes.cmsBlocks,
        permission: 'blocks.index',
      },
      {
        title: 'Články',
        url: routes.cmsArticles,
        permission: 'articles.index',
      },
      {
        title: 'Menu',
        url: routes.cmsMenu,
        permission: 'menu.index',
      },
      {
        title: 'Užitočné odkazy',
        url: routes.cmsUsefulLinks,
        permission: 'useful-links.index',
      },
    ],
  },
  {
    title: 'Fakulta',
    icon: <FontAwesomeIcon icon={'school'} />,
    items: [
      {
        title: 'Anketa',
        url: routes.cmsPolls,
        permission: 'polls.index',
      },
      {
        title: 'Dizertačné práce',
        url: routes.cmsDissertation,
        permission: 'dissertations.index',
      },

      {
        title: 'Kalendár',
        url: routes.cmsCalendar,
        permission: 'calendar.index',
      },
      {
        title: 'Pracoviská',
        url: routes.cmsDepartments,
        permission: 'departments.index',
      },
      {
        title: 'Študijné programy',
        url: routes.cmsStudyPrograms,
        permission: 'study-programs.index',
      },
      {
        title: 'Žltá knižka',
        url: routes.cmsYellowBooks,
        permission: 'yellow-books.index',
      },
    ],
  },
  {
    title: 'FRI.wiki',
    icon: <FontAwesomeIcon icon={'book-atlas'} />,
    items: [
      {
        title: 'Stránky',
        url: routes.cmsWikiPages,
        permission: 'wiki-pages.index',
      },
      {
        title: 'Kategórie',
        url: routes.cmsWikiCategories,
        permission: 'wiki-categories.index',
      },
    ],
  },
  {
    title: 'Rezervácia miestností',
    icon: <FontAwesomeIcon icon={'calendar-days'} />,
    items: [
      {
        title: 'Rezervácie',
        url: routes.cmsReservations,
        permission: 'reservations.index',
      },
      {
        title: 'Prehľad rezervácií',
        url: routes.cmsReservationOverview,
        permission: 'reservations.index',
      },
      {
        title: 'Miestnosti',
        url: routes.cmsRooms,
        permission: 'rooms-admin',
      },
      {
        title: 'Zodpovedné osoby',
        url: routes.cmsRoomResponsible,
        permission: 'rooms-admin',
      },
    ],
  },
  {
    title: 'Projekty inž. štúdia',
    icon: <FontAwesomeIcon icon={'diagram-project'} />,
    items: [
      {
        title: 'Projekty',
        url: routes.cmsIngProjects,
        permission: '',
      },
      {
        title: 'Priradený projekt',
        url: routes.cmsIngProjectsAssigned,
        permission: 'ing-projects-student',
      },
      {
        title: 'Študenti',
        url: routes.cmsIngPorjectsActiveStudents,
        permission: ['ing-projects-project-guarantee', 'ing-projects-study-program-guarantee'],
      },
      {
        title: 'Priradenie študentov',
        url: routes.cmsIngProjectsStudentAssignment,
        permission: ['ing-projects-study-program-guarantee', 'ing-projects-assignments', 'ing-projects-admin'],
      },
      {
        title: 'Žiadosti o zmenu',
        url: routes.cmsIngProjectsChangeRequests,
        permission: ['ing-projects-change-requests', 'ing-projects-student'],
      },
      {
        title: 'Nastavenia',
        url: routes.cmsIngProjectsSettings,
        permission: null,
        roles: [ROLE_ING_PROJECTS_ADMIN],
      },
    ],
  },
  !isProduction && {
    title: 'PhD štúdium',
    icon: <FontAwesomeIcon icon={'mortar-board'} />,
    items: [
      {
        title: 'Prehľad doktorandského štúdia',
        url: routes.cmsPhdDashboard,
        permission: 'phd-dashboard.view',
      },
      {
        title: 'Študijné odbory a predmety',
        url: routes.cmsPhdStudyFields,
        permission: 'phd-study-fields.store',
      },
      {
        title: 'Pracovné skupiny',
        url: routes.cmsPhdWorkingGroups,
        permission: 'phd-working-groups.index',
      },
      {
        title: 'Doktorandi',
        url: routes.cmsPhdStudents,
        permission: 'phd-students.index',
      },
      {
        title: 'Školitelia',
        url: routes.cmsPhdSupervisors,
        permission: 'phd-supervisors.index',
      },
      {
        title: 'Témy dizertačných prác',
        url: routes.cmsPhdTheses,
        permission: 'phd-theses.index',
      },
      {
        title: 'Individuálne plány',
        url: routes.cmsPhdIndividualPlans,
        permission: 'phd-individual-plans.index',
      },
      {
        title: 'Môj individuálny plán',
        url: routes.cmsPhdStudentPlan,
        permission: 'phd-student-plan.index',
      },
      {
        title: 'Prihlášky doktorandov',
        url: routes.cmsPhdApplications,
        permission: 'phd-system-states.store',
      },
      {
        title: 'Moje prihlášky',
        url: routes.cmsPhdMyApplications,
        permission: 'phd-student-plan.index',
      },
      {
        title: 'Návrhy oponentov',
        url: routes.cmsPhdExaminerProposals,
        permission: 'phd-examiner-proposals.index',
      },
      {
        title: 'Zadanie známok doktorandom',
        url: routes.cmsPhdStudentEvaluationGrades,
        permission: 'phd-student-evaluation-grades.index',
      },
      {
        title: 'Ročné hodnotenia doktorandov',
        url: routes.cmsPhdStudentEvaluations,
        permission: 'phd-student-evaluations.index',
      },
      {
        title: 'Nastavenia',
        url: routes.cmsPhdSettings,
        permission: 'phd-system-states.store',
      },
    ],
  },
  {
    title: 'FRI.edu',
    icon: <FontAwesomeIcon icon={'book-open'} />,
    items: [
      {
        title: 'Kurzy',
        url: routes.cmsCoursesList,
        permission: 'fri-edu-courses.index',
      },
      {
        title: 'Moje termíny',
        url: routes.cmsEduMyDates,
        permission: 'fri-edu-course-dates.index',
      },
    ],
  },
  {
    title: 'FRI.jobs',
    icon: <FontAwesomeIcon icon={'briefcase'} />,
    items: [
      {
        title: 'Naše pracovné ponuky',
        url: routes.cmsFriJobsJobs,
        permission: 'fri-jobs-partner',
      },
      {
        // For admins
        title: 'Pracovné ponuky',
        url: routes.cmsFriJobsJobs,
        permission: 'fri-jobs-admin',
      },
      {
        // For students
        title: 'Pracovné ponuky',
        url: routes.cmsFriJobsJobs,
        permission: 'fri-jobs-student',
      },
      {
        title: 'Môj záujem',
        url: routes.cmsFriJobsMyInterests,
        permission: 'fri-jobs-student',
      },
    ],
  },
  {
    title: 'FRI.Mobility',
    icon: <FontAwesomeIcon icon={'fa-solid fa-earth-europe'} />,
    items: [
      {
        title: 'Mapa univerzít',
        url: routes.cmsErasmusDashboard,
        permission: 'erasmus-applications.index',
      },
      {
        title: 'Prihlášky',
        url: routes.cmsErasmusApplication,
        permission: 'erasmus-applications.index',
      },
      {
        title: 'Mobility',
        url: routes.cmsErasmusMobility,
        permission: 'erasmus-mobilities.index',
      },
      {
        title: 'Univerzity',
        url: routes.cmsErasmusUniversity,
        permission: 'erasmus-universities.index',
      },
      {
        title: 'Konzorciá',
        url: routes.cmsErasmusConsortium,
        permission: 'erasmus-consortiums.index',
      },
      {
        title: 'Výzvy',
        url: routes.cmsErasmusChallenges,
        permission: 'erasmus-challenges.index',
      },
      {
        title: 'Predmety',
        url: routes.cmsErasmusSubjects,
        permission: 'erasmus-subjects.index',
      },
    ],
  },
  {
    title: 'FRI.open',
    icon: <FontAwesomeIcon icon={'door-open'} />,
    items: [
      {
        title: 'Akcie FRI',
        url: routes.cmsFoEventsList,
        permission: 'fo-events.index',
      },
      {
        title: 'Moje termíny',
        url: routes.cmsFoMyDatesList,
        permission: 'fo-events.index',
      },
    ],
  },
  {
    title: 'FRI.Prax',
    icon: <FontAwesomeIcon icon={'handshake'} />,
    items: [
      {
        title: 'FRI praxe',
        url: routes.cmsFijJobs,
        permission: 'fri-internal-jobs-jobs.index',
      },
      {
        title: 'Moje FRI praxe',
        url: routes.cmsFijJobListOfMyInterests,
        permission: 'fri-internal-jobs-student',
      },
    ],
  },
  {
    title: 'FRI.via',
    icon: <FontAwesomeIcon icon={'circle-question'} />,
    items: [
      {
        title: 'Kvízy',
        url: routes.cmsQuizzes,
        permission: 'quizzes.index',
      },
      {
        title: 'Moje odpovede',
        url: routes.cmsMyQuizAnswers,
        permission: 'quiz-student-answers.store',
      },
    ],
  },
  !isProduction && {
    title: 'Meteostanica',
    icon: <FontAwesomeIcon icon={'cloud-sun'} />,
    items: [
      {
        title: 'Správa senzorov',
        url: routes.cmsMeteoStationSensors,
        permission: 'meteo-station.index',
      },
      {
        title: 'Správa jednotiek',
        url: routes.cmsMeteoStationUnits,
        permission: 'meteo-station.index',
      },
    ],
  },
  !isProduction && {
    title: 'Dochádzka',
    icon: <FontAwesomeIcon icon={'calendar-check'} />,
    items: [
      {
        title: 'Moje dochádzky',
        url: routes.cmsAttendanceStudentOverview,
        permission: 'attendance.index',
      },
      {
        title: 'Rozvrh',
        url: routes.cmsAttendanceSchedule,
        permission: 'attendance-events.schedule',
      },
      {
        title: 'Moje udalosti',
        url: routes.cmsAttendanceMyEvents,
        permission: 'attendance-events.show',
      },
      {
        title: 'Prehľad účastí',
        url: routes.cmsAttendanceTeacherOverview,
        permission: 'attendance.show',
      },
      {
        title: 'Všetky udalosti',
        url: routes.cmsAttendanceEvents,
        permission: 'attendance-events.admin',
      },
    ],
  },
  {
    title: 'Správa vyhľadávania',
    icon: <FontAwesomeIcon icon={'fa-solid fa-magnifying-glass'} />,
    items: [
      {
        title: 'História vyhľadávania',
        url: routes.cmsSearchHistory,
        permission: 'search-history.index',
      },
      {
        title: 'Správa vyhľadávania',
        url: routes.cmsSearchAdmin,
        permission: 'search-admin.index',
      },
    ],
  },
  {
    title: 'Správa portálu',
    icon: <FontAwesomeIcon icon={'user-cog'} />,
    items: [
      {
        title: 'FRI používatelia',
        url: routes.cmsUsers,
        permission: 'users.index',
      },
      {
        title: 'Externí používatelia',
        url: routes.cmsExternalUsers,
        permission: 'external-users.index',
      },
      {
        title: 'Externí partneri FRI',
        url: routes.cmsExternalPartners,
        permission: 'external-partners.index',
      },
      {
        title: 'Role',
        url: routes.cmsRoles,
        permission: 'roles.index',
      },
      {
        title: 'Oprávnenia',
        url: routes.cmsPermissions,
        permission: 'permissions.index',
      },
      {
        title: 'Súbor denníka',
        url: routes.cmsLogs,
        permission: 'logs.index',
      },
      {
        title: 'Pomocník',
        url: routes.cmsHelp,
        permission: 'help.index',
      },
    ],
  },
];

export default navItems;
